const playerLandingReducer = (state = null, action) => {
  switch (action.type) {
    case 'ADMIN_PLAYER_LANDING':
      return action.data
    default:
      return state
  }
}

export default playerLandingReducer
